export default __webpack_public_path__ + "static/media/Tierp_full.af94b021.png";